import Decimal from 'decimal.js-light'

Decimal.set({
  precision: 20,
  rounding: Decimal.ROUND_DOWN,
})

export const isNumberFormatSupported = 'Intl' in globalThis && 'NumberFormat' in Intl

export function add(a = 0, b = 0) {
  return new Decimal(a).add(b)
}

export function sub(a = 0, b = 0) {
  return new Decimal(a).sub(b)
}

export function mul(a = 0, b = 0) {
  return new Decimal(a).mul(b)
}

export function div(a = 0, b = 1) {
  return new Decimal(a).div(b)
}

const fixFormatCache = {}
export function fix(a, n = 0, { useGrouping = true, stripZero = false, ...rest } = {}) {
  if (Number.isNaN(+a))
    return a
  n = +n
  const key = useGrouping ? -n : n
  if (!fixFormatCache[key]) {
    const { format } = isNumberFormatSupported ? new Intl.NumberFormat('en-us', { minimumFractionDigits: n, useGrouping, ...rest }) : {}
    fixFormatCache[key] = format ?? false
  }
  const res = new Decimal(a).toFixed(n)
  let formatted = fixFormatCache[key] ? fixFormatCache[key](res) : res
  // stripZero 去除末尾多余的0
  if (stripZero && typeof formatted === 'string' && formatted.includes('.')) {
    formatted = formatted.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '').replace(/\.$/, '')
  }
  return formatted
}
export function fixRaw(a, n = 0, rm = Decimal.ROUND_DOWN) {
  if (isInvalidNum(a))
    return a

  return new Decimal(a).toFixed(n, rm)
}
const persentCache = {}
function fn(num) {
  const { format } = isNumberFormatSupported ? new Intl.NumberFormat('en-us', { style: 'percent', minimumFractionDigits: num }) : {}
  return format
}
export function percent(a, sp = 2, prefix = true) {
  if (Number.isNaN(+a))
    return a

  persentCache[sp] = persentCache[sp] || fn(sp)
  if (persentCache[sp])
    return (prefix && a > 0 ? '+' : '') + persentCache[sp](a)

  return a
}

export const integerPercent = (v, sp = 0) => Number.isNaN(v) ? v : percent(v / 100, sp, false)

export function floor(a, n) {
  if (Number.isNaN(a))
    return a

  const num = new Decimal(a).toFixed(n + 1)
  return num.slice(0, num.length - 1)
}

export const dot = fix(0, 1).replace(/0/g, '')
export function getPrecision(n, spliter = '.') {
  return `${n}`.split(spliter)[1]?.length ?? 0
  // return new Decimal(n).toFixed().split('.')[1]?.length ?? 0;
}

const { format: s2lFormat } = isNumberFormatSupported ? new Intl.NumberFormat('en-us', { maximumSignificantDigits: 20 }) : {}
export function s2l(n) {
  if (Number.isNaN(n))
    return n

  if (s2lFormat)
    return s2lFormat(n)

  return n
}

export const clamp = (n, min, max) => Math.min(Math.max(n, min), max)

export function isInvalidNum(n) {
  return Number.isNaN(+n) || n === null || n === ''
}

export function toHuman(n, precision, lang = 'en-us', optioin = {}) { // KMB缩写 1.23M
  return Number.isNaN(+n) ? n : n < 1e6 ? fix(n, precision) : (+n).toLocaleString(lang, { notation: 'compact', compactDisplay: 'short', maximumFractionDigits: 3, roundingPriority: 'lessPrecision', useGrouping: false, ...optioin })
}
